"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prefetchMeetingData = prefetchMeetingData;
exports.getInlineMeetingParams = getInlineMeetingParams;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _params = require("hub-http/helpers/params");

var _getUserInfo = require("ui-addon-upgrades/_core/common/api/getUserInfo");

var linkParams;
var BASE_PARAMS = {
  embed: true
};

function prefetchMeetingData() {
  (0, _getUserInfo.getUserInfo)().then(function (_ref) {
    var user = _ref.user,
        portal = _ref.portal;
    linkParams = {
      firstName: user.first_name,
      lastName: user.last_name,
      email: user.email,
      website: portal.domain
    };
  }).catch(function () {
    linkParams = {
      firstName: null,
      lastName: null,
      email: null,
      website: null
    };
  });
}

function getInlineMeetingParams(upgradeData) {
  var hasAssignedRep = !!(upgradeData.repInfo && upgradeData.repInfo.link);
  var attributionSource = hasAssignedRep ? 'rep' : 'ISC';
  var meetingParams = {
    meeting_funnel: 'in-app',
    meeting_medium: 'pql',
    meeting_product: upgradeData.upgradeProduct,
    meeting_source: upgradeData.source,
    meeting_type: attributionSource,
    meeting_campaign: attributionSource
  };
  return (0, _params.stringify)((0, _extends2.default)({}, linkParams, meetingParams, BASE_PARAMS));
}